/* @ngInject */
function emojisService (ConnectorWebService, Utils, CONSTANTS) {
  var service = {
    getEmojis
  }

  return service

  /**
   * @description - This function receives an object of emojis' names
   */
  function getEmojis (names) {
    const url = Utils.addQueryStringFromArray(CONSTANTS.URL_EMOJIS, 'emojis', names)

    return ConnectorWebService.get(url)
  }
}

export { emojisService }
